import React from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { withLocale } from 'routes/paths';
import { useLocale } from 'i18n/useLocale';

export const LocalizedLink = React.forwardRef(({ to, ...props }, ref) => {
  const lang = useLocale();
  return <RouterLink ref={ref} to={withLocale(to, lang)} {...props} />;
});

export const useLocalizedNavigate = () => {
  const lang = useLocale();
  const navigate = useNavigate();
  return (to, options) => navigate(withLocale(to, lang), options);
};
